import React from 'react';
import { observer } from 'mobx-react';

import { Modal } from '../../../common/modal';
import { SecondaryButton } from '../../../common/secondary-button';
import { ERROR_CODES } from '../../../models/ApiError';
import { goToPage, routeNaming } from '../../../routes';
import { CheckoutStore, CHECKOUT_STAGES } from '../../../stores/CheckoutStore';
import styles from './ErrorModal.css';

const defaultData = {
  actionStage: null,
  actionText: 'Volver al carrito',
  text: 'Parece que estamos experimentando un problema, por favor intente realizar su pedido nuevamente',
};

const errorData = {
  [ERROR_CODES.INVALID_ADDRESS]: defaultData,
  [ERROR_CODES.CHECKOUT_INVALID_ADDRESS_FIELDS]: defaultData,
  [ERROR_CODES.NO_SHIPPING_FOR_ADDRESS]: {
    actionStage: CHECKOUT_STAGES.CHOOSE_ADDRESS,
    actionText: 'Seleccionar otra',
    text: 'Lamentablemente ya no entregamos a la dirección seleccionada',
  },
  [ERROR_CODES.INVALID_CHECKOUT_PARAMS]: defaultData,
  [ERROR_CODES.CHECKOUT_CART_PRICE_MISMATCH]: {
    actionStage: null,
    actionText: 'Volver al carrito',
    text: 'Los precios de los productos que ha seleccionado han cambiado. Por favor revise los cambios e intente nuevamente',
  },
  [ERROR_CODES.CHECKOUT_SHIPPING_PRICE_MISMATCH]: {
    actionStage: CHECKOUT_STAGES.SHIPPING_OPTIONS,
    actionText: 'Elegir envío nuevamente',
    text: 'Los precios de envío han cambiado. Por favor revise su pedido e intente nuevamente',
  },
  [ERROR_CODES.CHECKOUT_CART_EMPTY]: defaultData,
  [ERROR_CODES.CHECKOUT_INVALID_PAYMENT_TYPE]: defaultData,
  [ERROR_CODES.CHECKOUT_INVALID_SHIPPING_TYPE]: defaultData,
  [ERROR_CODES.CHECKOUT_BILLED_OR_CANCELED]: defaultData,
  [ERROR_CODES.CHECKOUT_CART_ITEM_EXCEEDED_AMOUNT]: defaultData,
  [ERROR_CODES.CLIENT_BANNED]: defaultData,
};

const goToStage = (stage) => {
  goToPage(routeNaming.CHECKOUT, { checkoutStep: stage });
};

const generateAction = actionStage => () => {
  if (actionStage) {
    goToStage(actionStage);
  } else {
    goToPage(routeNaming.CART);
  }
};

const ErrorModal = () => {
  const data = errorData[CheckoutStore.creationError ? CheckoutStore.creationError.code : null]
  || defaultData;
  return (
    <Modal>
      <div className={styles.container}>
        <p className={styles.text}>
          {data.text}
        </p>
        <SecondaryButton
          className={styles.button}
          onClick={generateAction(data.actionStage)}
        >
          {data.actionText}
        </SecondaryButton>
      </div>
    </Modal>
  );
};

const ObservedErrorModal = observer(ErrorModal);

export { ObservedErrorModal as ErrorModal };



// WEBPACK FOOTER //
// ./src/pages/confirm-checkout/error-modal/ErrorModal.jsx